// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Page from "@insite/mobius/Page";
import * as React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    cartUrl: getPageLinkByPageType(state, "CartPage")?.url || "/Cart",
});

export interface RequestQuoteFormPageStyles {
    backToCart?: LinkPresentationProps;
}

export const requestQuoteFormPageStyles: RequestQuoteFormPageStyles = {};

const styles = requestQuoteFormPageStyles;

type Props = PageProps & ReturnType<typeof mapStateToProps>;

const RequestQuoteFormPage: React.FC<Props> = ({ id, cartUrl }) => {
    return (
        <Page>
            <Link {...styles.backToCart} href={cartUrl}>
                {translate("Return to Cart")}
            </Link>
            <Zone contentId={id} zoneName="Content"></Zone>
        </Page>
    );
};

const requestQuoteFormPageModule: PageModule = {
    component: connect(mapStateToProps)(RequestQuoteFormPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default requestQuoteFormPageModule;
